import dayjs from 'hb-react/shared/utils/dayjs/dayjs';

const getTimezoneName = (timezone) =>
  timezone.startsWith('+') || timezone.startsWith('-')
    ? `UTC${timezone}`
    : timezone;

const getDateStr = ({ startDate, endDate, timezone }) => {
  const localStartDate = dayjs(startDate).tz(timezone);
  const localStartTimezoneName = getTimezoneName(localStartDate.format('z'));
  const dateElems = [];
  const localStartTime = localStartDate.format('LT');

  if (!endDate) {
    dateElems.push(localStartDate.format('LL'));
    dateElems.push(localStartTime);
    dateElems.push(localStartTimezoneName);

    return dateElems.join(' ');
  }

  const localEndDate = dayjs(endDate).tz(timezone);
  const localEndTimezoneName = getTimezoneName(localEndDate.format('z'));
  const localEndTime = localEndDate.format('LT');

  if (localStartDate.format('L') === localEndDate.format('L')) {
    dateElems.push(dayjs(startDate).tz(timezone).format('LL'));
    dateElems.push(localStartTime);

    if (
      localStartTime === localEndTime ||
      localStartTimezoneName !== localEndTimezoneName
    ) {
      dateElems.push(localStartTimezoneName);
    }
    if (localStartTime !== localEndTime) {
      dateElems.push('-');
      dateElems.push(localEndTime);
      dateElems.push(localEndTimezoneName);
    }
  } else {
    dateElems.push(localStartDate.format('LL'));
    dateElems.push(localStartTime);
    if (localStartTimezoneName !== localEndTimezoneName) {
      dateElems.push(localStartTimezoneName);
    }
    dateElems.push('-');
    dateElems.push(localEndDate.format('LL'));
    dateElems.push(localEndTime);
    dateElems.push(localEndTimezoneName);
  }

  return dateElems.join(' ');
};
export default getDateStr;
